import type { ComponentProps } from 'react'

import { cn } from '@/shared/lib/cn'

/**
 * Pílula cinza de carregamento. O nibo reproduz a GRADE REAL de colunas no
 * skeleton (larguras variáveis por coluna), não barras uniformes — quem usa
 * reconhece a tela antes dos dados chegarem.
 *
 * `animate-pulse` é neutralizado por prefers-reduced-motion (globals.css).
 */
export type SkeletonProps = ComponentProps<'div'>

export function Skeleton({ className, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('bg-surface-3 animate-pulse rounded-sm', className)}
      aria-hidden="true"
      {...props}
    />
  )
}
